/* tslint:disable: no-object-literal-type-assertion */
import createReactContext from '@ant-design/create-react-context'; // We will never use default, here only to fix TypeScript warning

var MentionsContext = createReactContext(null);
export var MentionsContextProvider = MentionsContext.Provider;
export var MentionsContextConsumer = MentionsContext.Consumer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-mentions/es/MentionsContext.js
// module id = 705
// module chunks = 0